import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    heightPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    safeArea: {
        flex: 1,
        backgroundColor: COLOR.background,
    },
    scroll: {
        flex: 1,
        paddingBottom:
            heightPercentageToDP(24) + (androidScreenMarginBottom ?? 0),
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
    backgroundStyle: {
        backgroundColor: COLOR.background,
    },
});

export default styles;
